/**
 * Created by Eric on 8/4/16.
 */
'use strict';

angular.module('clientDashboardApp').directive('parentWidth',function($window){
  return {
    restrict: 'A',
    scope: {
      refresh: '='
    },
    link: function(scope,elem,attr,ctrl){
      // var w = angular.element($window);
      // w.bind('resize', function() {
      //   clearWidth();
      //   setWidth();
      //   scope.$apply();
      // });
      // w.bind('resizeEnd', function() {
      //   setWidth();
      //   scope.$apply();
      // });
      // function setWidth(){
      //   $(elem).css({width:$(elem).parent().innerWidth()})
      // }
      // function clearWidth(){
      //   $(elem).attr('style',$(elem).css().replaceAll(/width:.*?;/,''));
      // }
      // setWidth();
      // scope.$watch('refresh',(newVal) => {
      //   setWidth();
      // })
    }
  }
})
